import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
  Fade
} from "@mui/material";

import CardVehiculos from "../components/mapa/CardVehiculos";
import MostrarMapa from "../components/mapa/MostrarMapa";

// 🔥 CAMBIO CLAVE 1: Importamos nuestra instancia configurada en lugar de 'axios' directo.
// (Asegúrate de que la ruta apunte correctamente al archivo donde creaste el interceptor)
import api from "../assets/utils/axiosConfig"; 

import SearchIcon from "@mui/icons-material/Search";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PushPinIcon from "@mui/icons-material/PushPin";

const MapaPage = () => {
  const [vehiculos, setVehiculos] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [centroMapa, setCentroMapa] = useState({
    lat: -33.45,
    lng: -70.65,
  });

  const [vehiculoSeleccionadoId, setVehiculoSeleccionadoId] = useState(null);
  const [modoPanel, setModoPanel] = useState("compacto");

  useEffect(() => {
    const fetchData = async () => {
      try {
        // 🔥 CAMBIO CLAVE 2: Ya no buscamos el token ni configuramos los headers.
        // El archivo axiosConfig.js lo hace todo de forma automática.
        const response = await api.post(process.env.REACT_APP_API_MAPA_VEHICULOS, {});

        const data = Array.isArray(response.data) ? response.data : [];

        setVehiculos(
          data.map((v) => ({
            ...v,
            latitude: Number(v.latitude),
            longitude: Number(v.longitude),
          }))
        );
      } catch (err) {
        console.error("Error al obtener vehículos:", err);
        setVehiculos([]);
      }
    };

    fetchData();
    const interval = setInterval(fetchData, 10000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!vehiculoSeleccionadoId) return;

    const v = vehiculos.find(
      (x) => x.idVehiculo === vehiculoSeleccionadoId
    );

    if (v?.latitude && v?.longitude) {
      setCentroMapa({
        lat: v.latitude,
        lng: v.longitude,
      });
    }
  }, [vehiculos, vehiculoSeleccionadoId]);

  const vehiculosFiltrados = vehiculos.filter((v) => {
    const t = busqueda.toLowerCase();
    return (
      v.patente?.toLowerCase().includes(t) ||
      v.modelo?.toLowerCase().includes(t)
    );
  });

  const handleSelectVehiculo = (vehiculo) => {
    if (vehiculoSeleccionadoId === vehiculo.idVehiculo) {
      setVehiculoSeleccionadoId(null);
      return;
    }

    setVehiculoSeleccionadoId(vehiculo.idVehiculo);
    setCentroMapa({
      lat: vehiculo.latitude,
      lng: vehiculo.longitude,
    });
  };

  return (
    <Box sx={{ height: "100%", width: "100%", position: "relative" }}>
      <MostrarMapa
        vehiculos={vehiculos}
        centro={centroMapa}
        seguimientoActivo={!!vehiculoSeleccionadoId}
        onDesactivarSeguimiento={() => setVehiculoSeleccionadoId(null)}
      />

      {/* BOTÓN FLOTANTE SIEMPRE VISIBLE */}
      <Box
        sx={{
          position: "absolute",
          top: 20,
          right: modoPanel === "compacto" ? 20 : 340,
          zIndex: 20,
          transition: "all .3s"
        }}
      >
        <Tooltip title={modoPanel === "compacto" ? "Expandir" : "Contraer"}>
          <IconButton
            onClick={() =>
              setModoPanel(modoPanel === "compacto" ? "expandido" : "compacto")
            }
            sx={{
              width: 44,
              height: 44,
              borderRadius: "12px",
              backdropFilter: "blur(10px)",
              background: "rgba(15, 23, 42, 0.7)",
              color: "#fff",
              boxShadow: "0 8px 25px rgba(0,0,0,0.35)",
              "&:hover": {
                background: "rgba(15, 23, 42, 0.9)",
                transform: "scale(1.05)"
              }
            }}
          >
            {modoPanel === "compacto" ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </Tooltip>
      </Box>

      {/* PANEL */}
      <Fade in={modoPanel !== "compacto"}>
        <Box
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            bottom: 10,
            width: 320,
            borderRadius: "20px",
            backdropFilter: "blur(18px)",
            background: "rgba(255,255,255,0.75)",
            boxShadow: "0 20px 50px rgba(0,0,0,0.25)",
            border: "1px solid rgba(255,255,255,0.4)",
            display: modoPanel === "compacto" ? "none" : "flex",
            flexDirection: "column",
            overflow: "hidden"
          }}
        >
          {/* HEADER */}
          <Box
            sx={{
              px: 2,
              py: 1.5,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <TextField
              size="small"
              placeholder="Buscar vehículo..."
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
              sx={{ flex: 1 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />

            <Tooltip title="Fijar panel">
              <IconButton
                onClick={() =>
                  setModoPanel(
                    modoPanel === "fijado" ? "expandido" : "fijado"
                  )
                }
              >
                <PushPinIcon
                  color={modoPanel === "fijado" ? "primary" : "inherit"}
                />
              </IconButton>
            </Tooltip>
          </Box>

          {/* LISTA */}
          <Box sx={{ flex: 1, overflowY: "auto", p: 1 }}>
            {vehiculosFiltrados.map((vehiculo) => (
              <CardVehiculos
                key={vehiculo.idVehiculo}
                vehiculo={vehiculo}
                compacto={false}
                onSelectVehiculo={handleSelectVehiculo}
                seleccionado={
                  vehiculoSeleccionadoId === vehiculo.idVehiculo
                }
              />
            ))}
          </Box>
        </Box>
      </Fade>

      {/* MODO COMPACTO (ICONOS FLOTANTES) */}
      {modoPanel === "compacto" && (
        <Box
          sx={{
            position: "absolute",
            top: 80,
            right: 12,
            display: "flex",
            flexDirection: "column",
            gap: 1,
            zIndex: 10
          }}
        >
          {vehiculosFiltrados.slice(0, 10).map((vehiculo) => (
            <CardVehiculos
              key={vehiculo.idVehiculo}
              vehiculo={vehiculo}
              compacto
              onSelectVehiculo={handleSelectVehiculo}
              seleccionado={
                vehiculoSeleccionadoId === vehiculo.idVehiculo
              }
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default MapaPage;